export const exceptionTypes = {
  hedge_required: 'hedge_required',
  hedge_not_required: 'hedge_not_required',
};
